"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SameSite = exports.AuthClientId = void 0;
var auth_client_id_enum_1 = require("./auth-client-id.enum");
Object.defineProperty(exports, "AuthClientId", { enumerable: true, get: function () { return auth_client_id_enum_1.AuthClientId; } });
var same_site_enum_1 = require("./same-site.enum");
Object.defineProperty(exports, "SameSite", { enumerable: true, get: function () { return same_site_enum_1.SameSite; } });
